import { getOrderMortgagePayoffs } from "graphql/mortgage-payoffs/queries/getOrderMortgagePayoffs";
import { useQuery } from "react-query";
import { OrderProperty } from "types/order";

type Params = {
  orderId: string,
  selectedProperty: OrderProperty,
}

type PropertyMortgagePayoff = {
  mortgageId: string,
  loanNumber: string,
  amount: string
}

export const useMortgagePayoff = ({
  orderId,
  selectedProperty
}: Params) => {
  const { data, isLoading } = useQuery(["properties-mortgage-payofss", orderId],
    () => getOrderMortgagePayoffs({
      id: orderId,
      filters: { accounting: "/total_due/" }
    })
  );

  const propertyMortgages = data?.getOrder.mortgages
    .filter((mortage) => mortage.estate !== null && mortage.estate._id === selectedProperty._id) ?? [];

  const mortgages: PropertyMortgagePayoff[] = propertyMortgages.map((mortgage) => {
    return {
      mortgageId: mortgage._id,
      amount: mortgage.accounting.length ? mortgage.accounting[0].amount : 0,
      loanNumber: mortgage.loan_number
    };
  });

  return ({
    mortgages,
    isLoading
  });
};